import { format } from "date-fns";
import {
  getAllTasks,
  getCurrentApproversBatch,
} from "../../../api/hrm/tasks/task_info";

export function todayIso() {
  return format(new Date(), "yyyy-MM-dd");
}

export function monthRange() {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth(), 1);
  const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  return {
    from_date: format(first, "yyyy-MM-dd"),
    to_date: format(last, "yyyy-MM-dd"),
  };
}

export function taskTitle(t) {
  return (
    t.taskname ||
    t.title ||
    t.task_name ||
    (Array.isArray(t.task_list) && t.task_list[0]?.taskname) ||
    `Công việc #${t.id}`
  );
}

export function statusMeta(status) {
  const s = String(status || "").toLowerCase();
  if (s === "waiting")
    return {
      label: "Chờ duyệt",
      chip: "bg-amber-50 text-amber-700 border-amber-100",
    };
  if (s === "reported")
    return {
      label: "Đã báo cáo",
      chip: "bg-violet-50 text-violet-700 border-violet-100",
    };
  if (s === "approved")
    return {
      label: "Đã duyệt",
      chip: "bg-sky-50 text-sky-700 border-sky-100",
    };
  if (s === "completed")
    return {
      label: "Hoàn thành",
      chip: "bg-emerald-50 text-emerald-700 border-emerald-100",
    };
  if (s.includes("reject"))
    return {
      label: "Từ chối",
      chip: "bg-rose-50 text-rose-700 border-rose-100",
    };
  return {
    label: status || "—",
    chip: "bg-slate-50 text-slate-600 border-slate-100",
  };
}

/** Load month tasks + can_approve flag (same idea as WorkHubScreen). */
export async function loadEnrichedMonthTasks(currentUserId) {
  const range = monthRange();
  const data = await getAllTasks({ ...range, summary_mode: 1 });
  const items = Array.isArray(data?.items) ? data.items : [];

  const candidates = items.filter((t) => {
    const s = String(t.status || "").toLowerCase();
    return s === "waiting" || s === "reported";
  });
  const ids = [...new Set(candidates.map((t) => t.id).filter(Boolean))];

  let approverMap = {};
  if (ids.length > 0) {
    try {
      const batchRes = await getCurrentApproversBatch(ids);
      (batchRes?.data || []).forEach((item) => {
        approverMap[item.task_id] = item.approvers || [];
      });
    } catch {
      approverMap = {};
    }
  }

  return items.map((t) => {
    const approvers = approverMap[t.id] || [];
    const canApprove = approvers.some(
      (a) => String(a.id) === String(currentUserId)
    );
    return { ...t, can_approve: canApprove };
  });
}

export const WORK_LIST_MODES = {
  "need-approve": {
    title: "Cần bạn duyệt",
    subtitle: "Việc đang chờ bạn phê duyệt / chấm điểm",
    tone: "rose",
    empty: "Không có việc cần bạn duyệt",
    filter: (tasks, today) =>
      tasks.filter((t) => {
        const s = String(t.status || "").toLowerCase();
        return t.can_approve && (s === "waiting" || s === "reported");
      }),
  },
  today: {
    title: "Việc hôm nay",
    subtitle: "Công việc trong ngày còn đang mở",
    tone: "amber",
    empty: "Hôm nay không còn việc đang mở",
    filter: (tasks, today) =>
      tasks.filter((t) => {
        const day = String(t.work_day || "").slice(0, 10);
        const s = String(t.status || "").toLowerCase();
        return day === today && s !== "completed" && !s.includes("reject");
      }),
  },
  waiting: {
    title: "Chờ duyệt",
    subtitle: "Công việc tháng này ở trạng thái chờ duyệt",
    tone: "sky",
    empty: "Không có việc chờ duyệt",
    filter: (tasks) =>
      tasks.filter((t) => String(t.status || "").toLowerCase() === "waiting"),
  },
  reported: {
    title: "Đã báo cáo",
    subtitle: "Công việc đã gửi báo cáo, chờ chấm điểm",
    tone: "violet",
    empty: "Không có việc đã báo cáo",
    filter: (tasks) =>
      tasks.filter((t) => String(t.status || "").toLowerCase() === "reported"),
  },
};
